export { default } from "./OptimizedImage";
export * from "./OptimizedImage";
